import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Header.module.scss";
import { useTranslation } from "react-i18next";
import Arrow from "../imgs/arrow.svg";
import Logo from "../imgs/logo.png";
import LogoWithoutText from "../imgs/logo.png";
import { Drawer } from "@mui/material";
import { setToolsDrawer } from "../redux/slices/rootSlice.js";
import { useAppDispatch, useAppSelector } from "../redux/store.js";
import Menu from "../imgs/menu.svg";
import Cross from "../imgs/cross.svg";
import secureLocalStorage from "react-secure-storage";
import Select, {components} from 'react-select';
import LanguageButton from "./LanguageButton.jsx";

export default function Header() {
  const { t,i18n } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const dispatch = useAppDispatch();
  const [language, setLanguage] = useState(false);
  const languageRef = useRef(null);
  const toolsDrawer = useAppSelector((state) => state.root.toolsDrawer);
  const [aboutUsDrawer, setAboutUsDrawer] = useState(false);
  const [menuDrawer, setMenuDrawer] = useState(false);
  // const languages = ["en", "de", "pl", "fr", "it", "cz"];
  const languages = [
    {
        value: 'en',
        label: 'English',
        flag: "https://flagcdn.com/w320/us.png"
    },
    {
        value: 'pl',
        label: 'Polski',
        flag: "https://flagcdn.com/w320/pl.png"
    },
    {
        value: 'de',
        label: 'Deutsch',
        flag: "https://flagcdn.com/w320/de.png"
    },
    {
        value: 'fr',
        label: 'Français',
        flag: "https://flagcdn.com/w320/fr.png"
    },
    {
        value: 'cz',
        label: 'Czech',
        flag: "https://flagcdn.com/w320/cz.png"
    },
    {
        value: 'it',
        label: 'Italian',
        flag: "https://flagcdn.com/w320/it.png"
    },
    {
        value: 'es',
        label: 'Español',
        flag: "https://flagcdn.com/w320/es.png"
    },
  ]

  useEffect(() => {
    const storedLang = secureLocalStorage.getItem("lang");
    if (!storedLang) {
      changeLanguage("en");
    } else {
      i18n.changeLanguage(storedLang);
    }
  }, []);

  function changeLanguage(e) {
      i18n.changeLanguage(e);
      secureLocalStorage.setItem("lang", e);
    }
    const handleSetLanguage = () => {
      setLanguage((prev) => !prev);
    };
  const handleSetToolsDrawer = () => {
    dispatch(setToolsDrawer(!toolsDrawer));
  };

  const handleSetAboutUsDrawer = () => {
    setAboutUsDrawer(!aboutUsDrawer);
  };

  const handleSetMenuDrawer = () => {
    setMenuDrawer(!menuDrawer);
  };

  useEffect(() => {
    if (toolsDrawer || aboutUsDrawer) {
      setMenuDrawer(false);
    }
  }, [toolsDrawer, aboutUsDrawer]);

  useEffect(() => {
    if (toolsDrawer || aboutUsDrawer || menuDrawer) {
      document.body.style.position = "fixed";
    } else {
      document.body.style.position = "";
    }
  }, [toolsDrawer, aboutUsDrawer, menuDrawer]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const closeAllDrawers = () => {
    setAboutUsDrawer(false);
    setMenuDrawer(false);
    dispatch(setToolsDrawer(false));
  };

  const DropdownIndicator = ({ children, ...props }) => (
    <components.DropdownIndicator {...props}>
        <div className={styles.single_value_container}>
            <div className={styles.custom_icon}>
                <svg width={"1.7vh"} height={"1.6vh"} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5003 6L8.83366 10L4.16699 6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            {children}
        </div>
    </components.DropdownIndicator>
);

const Control = ({ children, ...props }) => {
  return (
      <components.Control {...props}>
          <div className={styles.country_start}>
              <span className={children[0].props.selectProps.value
                  ? styles.flag : styles.icon}>
                  {children[0].props.selectProps.value
                      ? <img src={children[0].props.selectProps.value.flag} alt='flag' />
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" width={'1.7vh'} height={'1.6vh'} viewBox="0 0 17 16" fill="none">
                          <g clipPath="url(#clip0_420_48527)">
                              <ellipse cx="8.84733" cy="6.66667" rx="4.66667" ry="4.66667" stroke="#51525C" />
                              <path d="M3.51465 11.0415C4.77357 12.4481 6.60307 13.3333 8.63931 13.3333C12.4365 13.3333 15.5146 10.2551 15.5146 6.45798C15.5146 4.42173 14.6294 2.59223 13.2229 1.33331" stroke="#51525C" strokeLinecap="round" />
                              <path d="M5.51465 3.0351C5.90477 3.40352 6.70842 4.41053 6.80205 5.49122C6.88957 6.50137 7.5325 7.32219 8.51465 7.33331C8.89209 7.33758 9.27382 7.05481 9.27285 6.66337C9.27255 6.54233 9.25328 6.41857 9.22313 6.30471C9.1812 6.14634 9.17748 5.96415 9.26465 5.77777C9.56959 5.12576 10.1693 4.95062 10.6446 4.59652C10.8554 4.43948 11.0476 4.2738 11.1324 4.14036C11.3665 3.77194 11.6006 3.0351 11.4835 2.66669" stroke="#51525C" />
                              <path d="M13.5146 7.33331C13.3683 7.74711 13.2646 8.83331 11.6116 8.85055C11.6116 8.85055 10.1478 8.85055 9.70863 9.67814C9.35731 10.3402 9.56225 11.0575 9.70863 11.3333" stroke="#51525C" />
                              <path d="M8.84766 14.6666V13.3333" stroke="#51525C" strokeLinecap="round" />
                              <path d="M8.84798 14.6667H7.51465" stroke="#51525C" strokeLinecap="round" />
                              <path d="M10.181 14.6667H8.84766" stroke="#51525C" strokeLinecap="round" />
                          </g>
                          <defs>
                              <clipPath id="clip0_420_48527">
                                  <rect width={16} height={16} fill="white" transform="translate(0.847656)" />
                              </clipPath>
                          </defs>
                      </svg>

                  }
              </span>
              <div className={styles.country}>
                  {children}
              </div>
          </div>
      </components.Control>
  )
};
  const CustomOptionCountry = (props) => {
    const { innerProps, innerRef } = props;
    return (
        <div ref={innerRef} {...innerProps} className={props.isSelected ? styles.custom_option_selected : styles.custom_option}>
            <div className={styles.option_country}  >
                <img  src={props.data.flag} alt='flag'  style={{borderRadius:"50%"}}/>
                {props.data.label}
            </div>
        </div>)
  }

  const colourStylesCountry = {
      control: (styles) => ({
          ...styles,
          backgroundColor: 'transparent',
          width: '100%',
          minHeight: '48px',
          color: '#121926',
          border: '1px solid #26272B',
          boxShadow: 'none',
          borderRadius: '32px',
          fontSize: '14px',
          '.custom_select__indicators': {
              '.custom_select__indicator': {
                  padding: '0.4vh !important'
              }
          }
      }),
      menu: (styles) => ({
          ...styles,
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          outlined: 'none',
      }),
      placeholder: (styles) => ({
          ...styles,
          fontSize: '14px',
      }),
      menuList: (styles) => ({
          ...styles,
          outlined: 'none',
          background: '#1D1D20',
          color: '#fff',
          borderRadius: '24px',
          padding: '0.4vh 0.4vh',
          zIndex: '1',
          "::-webkit-scrollbar": {
              width: "4px",
              height: "0px",
          },
          "::-webkit-scrollbar-track": {
              background: "#1D1D20"
          },
          "::-webkit-scrollbar-thumb": {
              background: "#3F3F46",
              zIndex: '0'
          },
          "::-webkit-scrollbar-thumb:hover": {
              background: "#3F3F46"
          }
      }),
      multiValue: (styles) => ({
          ...styles,
          backgroundColor: 'transparent',
          color: '#121926',
          padding: 0,
      }),
      multiValueLabel: (styles) => ({
          ...styles,
          color: '#121926',
          padding: 0,
      }),
      multiValueRemove: (styles) => ({
          ...styles,
          display: 'none'
      }),
      input: (styles) => ({
          ...styles,
          backgroundColor: 'transparent',
          color: '#121926',
          fontSize: '14px'
      }),
      option: (styles, { data, isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isFocused || isSelected ? '#161C24' : undefined,
          color: data.color ? data.color : '#FCFCFC',
          fontSize: '1.4vh',
          lineHeight: '1.6vh',
          padding: '12px 4px 12px 12px',
          borderRadius: '32px',
          ':hover': {
              backgroundColor: '#2C2D30',
              color: '#FCFCFC',
          },
      }),
      singleValue: (baseStyles) => ({
          ...baseStyles,
          fontWeight: '400',
          fontFamily: "'Inter', sans-serif",
          color: '#FCFCFC',
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',
      }),
      value: (baseStyles) => ({
          ...baseStyles,
          fontSize: '14px',
      }),
  };
  return (
    <div className={styles.header}>
      {(toolsDrawer || aboutUsDrawer || menuDrawer) && (
        <div className={styles.overlay} onClick={closeAllDrawers}></div>
      )}

      <div className={styles.left_side}>
        <Link to="/" className={styles.logo_container}>
          <img src={LogoWithoutText} alt="logo" width='30px' height='30px'  style={{marginRight:'20px'}}/>
        <span>Pulsar Node</span>
        </Link>
        {windowWidth > 1100 && (
          <>
            <Link to="/accounts" className={styles.link}>
              {t("Account types")}
            </Link>
            <div onClick={handleSetToolsDrawer} className={styles.link}>
              {t("Tools")} <img src={Arrow} alt="arrow" />
            </div>
            <Link to="/bonuses" className={styles.link}>
              {t("Bonuses")}
            </Link>
            <div onClick={handleSetAboutUsDrawer} className={styles.link}>
              {t("About us")} <img src={Arrow} alt="arrow" />
            </div>
          </>
        )}
      </div>
      {windowWidth > 1100 ? (
        <div className={styles.right_side}>
          <div className={styles.buttons}>
        <LanguageButton />
      </div>
          <Link to="/login" className={styles.login_button}>
            {t("Login")}
          </Link>
          <Link to="/register" className={styles.register_button}>
            {t("Register")}
          </Link>
        </div>
      ) : toolsDrawer || aboutUsDrawer || menuDrawer ? (
        <div onClick={handleSetMenuDrawer} className={styles.right_side}>
          <img src={Cross} alt="icon" />
        </div>
      ) : (
        <div onClick={handleSetMenuDrawer} className={styles.right_side}>
          <img src={Menu} alt="icon" />
        </div>
      )}

      <Drawer
        sx={{
          "& .MuiBackdrop-root": {
            background: "none !important",
          },
        }}
        anchor="top"
        open={toolsDrawer}
        onClose={handleSetToolsDrawer}
        PaperProps={{
          style: {
            width: "100vw",
            marginTop: windowWidth > 1100 ? "68px" : "92px",
          },
        }}
      >
        <div className={styles.drawer}>
          <div className={styles.block}>
            <ul>
              {t("Heat-map")}
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/forexHeatMap"
              >
                {t("Forex Heat-map")}
              </Link>
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/stockHeatMap"
              >
                {t("Heat-map of the stock")}
              </Link>
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/etfHeatMap"
              >
                {t("ETF Heat-map")}
              </Link>
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/CryptoHeatMap"
              >
                {t("Crypto Coin Heat-map")}
              </Link>
            </ul>
          </div>
          <div className={styles.block}>
            <ul>
              {t("Analysis")}
              {/* <Link onClick={handleSetToolsDrawer} className={styles.li} to='/tools'>{t("Technical Analysis")}</Link> */}
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/cryptocurrencyMarket"
              >
                {t("Cryptocurrency Market")}
              </Link>
            </ul>
          </div>
          <div className={styles.block}>
            <ul>
              {t("News")}
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/economicCalendar"
              >
                {t("Economic Calendar")}
              </Link>
              <Link
                onClick={handleSetToolsDrawer}
                className={styles.li}
                to="/tools/topStories"
              >
                {t("Top Stories")}
              </Link>
            </ul>
          </div>
          {/* <div className={styles.block}>
            <ul className={styles.contacts}>
              {t("Contact Us")}
              <li>{t("Address: 123 Main Street, Suite 100,")} <br /> {t("New York, NY 10001")}</li>
              <br />
              <li>{t("Phone: +1 (555) 123-4567")} <br /> {t("Email: info@example.com")}</li>
            </ul>
          </div> */}
        </div>
      </Drawer>
      <Drawer
        sx={{
          "& .MuiBackdrop-root": {
            background: "none !important",
          },
        }}
        anchor="top"
        open={aboutUsDrawer}
        onClose={handleSetAboutUsDrawer}
        PaperProps={{
          style: {
            width: "100vw",
            marginTop: windowWidth > 1100 ? "68px" : "92px",
          },
        }}
      >
        <div className={styles.drawer}>
          <div className={styles.block}>
            <ul>
              {t("Partners")}
              <Link className={styles.li} to="/affiliate">
                {t("Affiliate program")}
              </Link>
            </ul>
          </div>
          <div className={styles.block}>
            <ul>
              {t("Company")}
              <Link className={styles.li} to="/about">
                {t("About company")}
              </Link>
              <Link className={styles.li} to="/privacy">
                {t("Privacy policy")}
              </Link>
            </ul>
          </div>
        </div>
      </Drawer>
      <Drawer
        sx={{
          "& .MuiBackdrop-root": {
            background: "none !important",
          },
        }}
        PaperProps={{
          style: {
            width: "100vw",
            marginTop: windowWidth > 1100 ? "68px" : "92px",
          },
        }}
        anchor="top"
        open={menuDrawer}
        onClose={handleSetMenuDrawer}
      >
        <div className={styles.menu_drawer}>
          <span className={styles.title}>{t("Menu")}</span>
          <div className={styles.list}>
            <Link to="/accounts" className={styles.list_item}>
              <div>
                <span>01</span>
                <p>{t("Account types")}</p>
              </div>
            </Link>
            <div onClick={handleSetToolsDrawer} className={styles.list_item}>
              <div>
                <span>02</span>
                <p>{t("Tools")}</p>
              </div>
              <div>
                <img src={Arrow} alt="arrow" />
              </div>
            </div>
            <Link to="/bonuses" className={styles.list_item}>
              <div>
                <span>03</span>
                <p>{t("Bonuses")}</p>
              </div>
            </Link>
            <div onClick={handleSetAboutUsDrawer} className={styles.list_item}>
              <div>
                <span>04</span>
                <p>{t("About us")}</p>
              </div>
              <div>
                <img src={Arrow} alt="arrow" />
              </div>
            </div>
          </div>
          <div className={styles.buttons}>
            <Link to='/login'>{t("Login")}</Link>
            <Link to='/register'>{t("Register")}</Link>
          </div>
          <div className={styles.language}>
            
                    <Select
                        value={languages.find(el => el.value === i18n.language)}
                        classNamePrefix="custom_select"
                        className={`${styles.select_select} custom-select-container`}
                        placeholder={'Country'}
                        menuPlacement='auto'
                        options={languages}
                        styles={colourStylesCountry}
                        components={{ DropdownIndicator, IndicatorSeparator: () => null, Option: CustomOptionCountry, Control }}
                        onChange={(selectedOption) => {i18n.changeLanguage(selectedOption.value);secureLocalStorage.setItem('lang', selectedOption.value);}}
                    />
          </div>
        </div>
      </Drawer>
    </div>
  );
}
